import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';

import { navComponent } from './modules/nav';
import { scrollState } from './modules/scrollState';
import { heroParallaxFunc } from './modules/hero-parallax';
import { numCounter } from './modules/num-counter';
import { swiperItems } from './modules/swipers';
import { accordionComponents } from './modules/accordions';
import { modalFunc } from './modules/modal';
import { TabbedSwitcher } from './modules/tabbed-switcher';
import { mapLinks } from './modules/map-links';
import { guideForm } from './modules/guide-form';

gsap.registerPlugin(ScrollTrigger);

import { domReady, pageReady } from './helpers';

domReady(() => {
	const markContentReady = () => {
		document.body.classList.add('content-ready');
	};

	// Always schedule first so a later init error cannot leave the page invisible.
	setTimeout(markContentReady, 3000);

	try {
		const $body = $('body');
		window.$body = $body;

		// Register before any init that might throw so the fade-in always runs.
		pageReady(() => {
			markContentReady();

			try {
				ScrollTrigger.refresh();
			} catch (error) {
				console.error('ScrollTrigger refresh failed:', error);
			}
		});
		window.gsap = gsap;
		window.ScrollTrigger = ScrollTrigger;
		window.Swiper = Swiper;
		window.Navigation = Navigation;
		window.FreeMode = FreeMode;

		/*************************************************
		 * Lenis Smooth Scroll
		*************************************************/
		const lenis = new Lenis({
			touchMultiplier: 0.5,
			allowNestedScroll: true,
		});

		lenis.on('scroll', ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);

		window.lenis = lenis;

		scrollState(lenis, $body);

		// Smooth scroll hash links via Lenis
		document.addEventListener('click', (e) => {
			const anchor = e.target.closest('a[href^="#"]');
			if (!anchor) return;

			const hash = anchor.getAttribute('href');
			if (!hash || hash === '#') return;

			const target = document.querySelector(hash);
			if (!target) return;

			e.preventDefault();
			lenis.scrollTo(target);
		});

		/*************************************************
		 * Utilities
		*************************************************/
		
		const hoverIcons = document.querySelectorAll("a.cta__btn.with-arrow .cta__link-arrow .icon");
		if (hoverIcons.length > 0) {
			hoverIcons.forEach((icon) => {
				const parent = icon.parentElement.parentElement;
				parent.addEventListener("pointerenter", () => {
						icon.classList.add("was-hovered");
				});
			});
		}

		/*************************************************
		 * Components
		*************************************************/

		const initComponent = (name, init) => {
			try {
				init();
			} catch (error) {
				console.error(`${name} failed:`, error);
			}
		};

		// Initialize Navigation
		initComponent('navComponent', navComponent);

		// Initialize Hero Parallax
		initComponent('heroParallaxFunc', heroParallaxFunc);

		// Initialize Number Counter
		initComponent('numCounter', numCounter);

		// Initialize Swipers
		initComponent('swiperItems', swiperItems);

		// Initialize Accordions
		initComponent('accordionComponents', accordionComponents);

		// Initialize Modal
		initComponent('modalFunc', modalFunc);

		// Initialize Tabbed Switcher
		initComponent('TabbedSwitcher', TabbedSwitcher);

		// Initialize Map Links
		initComponent('mapLinks', mapLinks);

		// Initialize Guide Download Form
		initComponent('guideForm', guideForm);
	} catch (error) {
		console.error('Scripts init failed:', error);
		markContentReady();
	}
});
